(() => {
  const paths = new Map([
    ['/products/custom-passport-leather-patch-hat', '/products/passport-leather-patch'],
    ['/products/painted-passport-leather-patch', '/products/full-color-passport'],
    ['/products/painted-passport-leather-patch-hat', '/products/full-color-passport'],
  ]);
  const updateLink = (link) => {
    if (!(link instanceof HTMLAnchorElement)) return;
    const href = link.getAttribute('href');
    if (!href) return;
    let url;
    try { url = new URL(href, window.location.origin); } catch { return; }
    if (url.origin !== window.location.origin) return;
    const path = paths.get(url.pathname);
    if (!path) return;
    url.pathname = path;
    link.setAttribute('href', href.startsWith('/') ? url.pathname + url.search + url.hash : url.href);
  };
  const updateTree = (root) => {
    if (!(root instanceof Element)) return;
    updateLink(root);
    root.querySelectorAll('a[href]').forEach(updateLink);
  };
  document.querySelectorAll('.loox-widget').forEach((widget) => {
    updateTree(widget);
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'attributes') updateLink(record.target);
        else record.addedNodes.forEach(updateTree);
      }
    });
    observer.observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  });
})();
